<div class="app-personal-form">
  <!-- Radio PF/PJ removido — selecao de tipo de conta agora e feita na tela select-account-type -->

  <div class="create-account-form-row">
    <aprova-input
      [control]="form.controls.nome"
      [label]="isPersonalAccount ? 'Nome' : 'Razão Social'"
      tabindex="1"
      maxlength="144"
      [required]="true"
      [disabled]="isFieldBlocked('nome')"
      [errorMessages]="{
        required: isPersonalAccount
          ? 'Preencha corretamente o nome.'
          : 'Preencha corretamente a razão social.'
      }"
    />

    <aprova-input
      [control]="form.controls.sobrenome"
      [label]="isPersonalAccount ? 'Sobrenome' : 'Nome Fantasia'"
      tabindex="2"
      maxlength="144"
      [required]="true"
      [disabled]="isFieldBlocked('sobrenome')"
      [errorMessages]="{
        required: isPersonalAccount
          ? 'Preencha corretamente o sobrenome.'
          : 'Preencha corretamente o nome fantasia.'
      }"
    />
  </div>

  <div class="create-account-form-row">
    <aprova-input
      class="w-full"
      [control]="form.controls.cpf"
      [label]="isPersonalAccount ? 'CPF' : 'CNPJ'"
      tabindex="3"
      [mask]="isPersonalAccount ? '000.000.000-00' : 'AA.AAA.AAA/AAAA-00'"
      [required]="true"
      [disabled]="isFieldBlocked('cpf')"
      [errorMessages]="{
        required: isPersonalAccount
          ? 'Por favor preencha o campo CPF.'
          : 'Por favor preenhca o campo CNPJ.',
        cpf: 'CPF inválido. Verifique e tente novamente.',
        cnpj: 'CNPJ inválido. Verifique e tente novamente.',
        cpfExists: 'Este CPF já está em uso.'
      }"
    />
    <aprova-input
      class="w-full"
      [control]="form.controls.telefone"
      label="Telefone ou celular"
      tabindex="4"
      [mask]="
        form.controls.telefone.value.length <= 10
          ? '(00) 0000-00009'
          : '(00) 00000-0000'
      "
      [required]="true"
      [disabled]="isFieldBlocked('telefone')"
      [errorMessages]="{
        required: 'Por favor preencha o campo telefone.',
        telefone: 'Número inválido. Verifique e tente novamente.'
      }"
    />
  </div>

  <div class="create-account-form-row">
    <aprova-input
      [control]="form.controls.email"
      label="E-mail"
      tabindex="5"
      noSpace
      maxlength="255"
      [required]="true"
      [disabled]="isFieldBlocked('email')"
      [errorMessages]="{
        required: 'Por favor preencha o campo de e-mail.',
        email: 'E-mail inválido. Verifique e tente novamente.',
        emailExists: 'Este e-mail já está em uso.'
      }"
    />

    <div class="w-full">
      <aprova-input
        [control]="form.controls.emailConfirmacao"
        label="Confirmar e-mail"
        tabindex="6"
        noSpace
        blockPaste
        maxlength="255"
        [required]="true"
        [disabled]="isFieldBlocked('emailConfirmacao')"
        [secureInput]="true"
        inputName="confirm_email_custom"
        (onFocus)="showEmailConfirmTooltip($event)"
        (onBlur)="clearFocusedField()"
        (onInput)="validateEmailConfirmRules()"
      />

      @if (focusedField() === 'emailConfirmacao' || form.controls.emailConfirmacao.hasError('emailMismatch')) {
        <div class="app-personal-form__rules">
          @for (rule of emailConfirmRules; track rule.label) {
            <div class="app-personal-form__rule" [class.app-personal-form__rule--valid]="rule.valid">
              <aprova-icon
                [name]="rule.valid ? 'check-circle-solid' : 'exclamation-circle-outline'"
                size="xs"
                [color]="rule.valid ? '#10B981' : '#EF4444'"
              />
              <span>{{ rule.label }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
